// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__js_iw","notification_container":"styles_notification_container__3nPBW","button":"styles_button__uRbdM"};